import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { useUserProfile, poiRelevanceByPartyType } from '../context/UserProfileContext';
interface POI {
  name: string;
  distance: number;
  categoryType: string;
  categoryLabel: string;
  icon: string;
}
interface RecommendedPOIsProps {
  nearbyPOIs: POI[];
}
export const RecommendedPOIs = ({
  nearbyPOIs
}: RecommendedPOIsProps) => {
  const {
    travelParty
  } = useUserProfile();
  // Get the relevant POI types for the current travel party
  const relevantPOITypes = poiRelevanceByPartyType[travelParty];
  // Filter and sort POIs based on relevance to the travel party
  const sortedPOIs = [...nearbyPOIs].sort((a, b) => {
    // First prioritize by relevance to travel party
    const aRelevanceIndex = relevantPOITypes.indexOf(a.categoryType);
    const bRelevanceIndex = relevantPOITypes.indexOf(b.categoryType);
    // If both are relevant, sort by relevance index
    if (aRelevanceIndex !== -1 && bRelevanceIndex !== -1) {
      return aRelevanceIndex - bRelevanceIndex;
    }
    // If only one is relevant, prioritize it
    if (aRelevanceIndex !== -1) return -1;
    if (bRelevanceIndex !== -1) return 1;
    // If neither is relevant, sort by distance
    return a.distance - b.distance;
  });
  // Take the top 5 POIs
  const topPOIs = sortedPOIs.slice(0, 5);
  if (topPOIs.length === 0) return null;
  // Get persona-specific label
  const personaLabel = travelParty === 'couple' ? 'couples' : travelParty === 'youngster' ? 'young travelers' : 'families';
  return <div className="mt-3" data-id="element-187">
      <h4 className="text-sm font-medium text-gray-700 mb-2" data-id="element-188">
        Recommended for {personaLabel}:
      </h4>
      <div className="grid grid-cols-1 gap-2" data-id="element-189">
        {topPOIs.map((poi, index) => <div key={`${poi.categoryType}-${index}`} className={`flex items-center gap-2 text-sm ${relevantPOITypes.includes(poi.categoryType) ? 'bg-rose-50 p-1 rounded-md' : ''}`} data-id="element-190">
            <img src={poi.icon} alt={poi.categoryLabel} className="w-4 h-4" data-id="element-191" />
            <span className="font-medium" data-id="element-192">{poi.name}</span>
            <div className="flex items-center text-gray-500" data-id="element-193">
              <MapPinIcon size={12} className="mr-1" data-id="element-194" />
              <span data-id="element-195">{poi.distance.toFixed(1)} km</span>
            </div>
          </div>)}
      </div>
    </div>;
};